import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
export const AuthorLinkedinIcon = ({
  url,
  style
}: {
  url: string
  style: string
}): JSX.Element => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon
        className={`${style}`}
        icon={faLinkedin}
      />
    </a>
  )
}
